import firebase from '@devradar/backend-firebase'
import testVolatile from './test-volatile'

export default {
  firebase,
  testVolatile
}
